import React from 'react';
import Card from './Card';
import Loading from './Loading';
import { useGlobalContext } from '../context';

const CardList = ({ selectedCards }) => {

  const { cards, loading } = useGlobalContext();

  if (loading) {
    return <Loading />;
  }

  if (!selectedCards) {
    return <h2 className="nomatches">no cards matched your criteria</h2>;
  }

  if (selectedCards.length === 0) {
    return (
      <div className="cards-center">
        {cards.map((item) => {
          return <Card key={item.id} {...item} />;
        })}
      </div>
    );
  }

  if (selectedCards.length > 0) {
    return (
        <div className="cards-center">
          {selectedCards.map((item) => {
            return <Card key={item.id} {...item} />
          })}
        </div>
    );
  };
};

export default CardList
